<!-- 表单的筛选 -->
<template>
  <div class="table__filter__status">
    <p>审核状态：</p>
    <el-select v-model="status" placeholder="请选择" @change="change" @clear="clear" clearable>
      <el-option :value="vuezero" label="未审核"></el-option>
      <el-option :value="vueone" label="审核通过"></el-option>
      <!-- <el-option :value="vuethree" label="草稿" v-if="showDraft"></el-option> -->
      <el-option :value="2" label="审核失败"></el-option>
      <el-option :value="vueminus" label="全部"></el-option>
    </el-select>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "ReviewSelect",
  
  mixins: [BaseVue],
  
  props: {
    // 显示精简模式
    showSimplifyMode: {
      type: Boolean,
      default: true
    },
    // 显示草稿选项
    showReviewOption: {
      type: Boolean,
      default: false
    },
    // 显示审核选项
    showDraft: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      status: 0
    };
  },
  
  methods: {
    init() {
      if (this.showSimplifyMode) {
        this.status = 0;
      } else {
        this.status = -1;
      }
      this.onDataChanged();
    },
    
    change() {
      // 改变状态的逻辑
    },
    
    clear() {
      this.status = 0;
    },
    
    onDataChanged() {
      let status = this.status;
      this.$emit("onDataChanged", status);
    },
    
    // extend
    initData(e) {
      console.log(123, e);
    }
  },
  
  mounted() {
    this.init();
  },
  
  watch: {
    status: {
      handler() {
        this.onDataChanged();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.box {
  display: flex;
  & > div {
    display: flex;
  }
  & ::v-deep .title {
    margin-right: 10px !important;
  }
}
</style>
